import React from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import './pagination.css';

const Pagination = ({ arrows, numeric, currentPage, totalPages, className, onPageChange }) => {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <div
      className={`col col-12 pagination__container ${className} ${arrows ? 'with-arrows' : ''} ${numeric ? 'with-numeric' : ''}`}
    >
      <div className="wrapper clearfix">
        {arrows &&
        <div className="pagination__prev__container">
          <button
            className={`pagination__prev ${currentPage === 1 ? 'hidden' : ''}`}
            onClick={() => onPageChange(currentPage - 1)}
          >
            « Previous page
          </button>
        </div>
        }
        {numeric &&
        <div className="pagination__numeric clearfix">
          <ReactPaginate
            previousLabel={''}
            nextLabel={''}
            pageCount={totalPages}
            containerClassName={'pagination'}
            activeClassName={'active'}
            breakLabel={<a disabled>...</a>}
            onPageChange={({ selected }) => onPageChange(selected + 1)}
            forcePage={currentPage - 1}
            disableInitialCallback
          />
        </div>
        }
        {arrows &&
        <div className="pagination__next__container">
          <button
            className={`pagination__next ${currentPage === totalPages ? 'hidden' : ''}`}
            onClick={() => onPageChange(currentPage + 1)}
          >
            Next page »
          </button>
        </div>
        }
      </div>
    </div>
  );
};

Pagination.propTypes = {
  arrows: PropTypes.bool,
  numeric: PropTypes.bool,
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  className: PropTypes.string,
  onPageChange: PropTypes.func.isRequired,
};

Pagination.defaultProps = {
  arrows: true,
  numeric: true,
  className: '',
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/pagination.js